/* ============================================================
   social.js — Profil public clicabil, listă de prieteni și
   mesaje directe (DM) private între jucători.
   Scripturi clasice (fără import/export), scope global partajat.
   DM-urile sunt stocate în tabela `direct_messages` (RLS: doar
   expeditorul și destinatarul au acces). Vezi direct_messages.sql.
   ============================================================ */

window._dmAll = [];          // toate DM-urile care mă implică
window._dmNames = {};        // id -> nume (cache)
window._dmTags = {};         // id -> user_tag (cache)
window._dmOpenWith = null;   // id-ul conversației deschise (modal)
var _dmChannel = null;

function _soEsc(s) { return window.escHtml(s); }
function _soMe() { return state.currentUser && state.currentUser.id; }

/* v9 8.1-c1: avatarul interlocutorului, pentru bara de sus a conversației. Din ce e
   deja în memorie (membrii clubului, prieteni, profilurile încărcate pentru DM-uri);
   fără cerere nouă. Gol ⇒ iconița implicită. EN: DM partner avatar from memory. */
function _dmAvatarFor(id) {
    if (!id) return '';
    try {
        var byId = (state && state.membersById) || {};
        if (byId[id] && byId[id].avatar) return byId[id].avatar;
        var m = (state && state.members) || {};
        for (var k in m) { if (m[k] && m[k].dbId === id && m[k].avatar) return m[k].avatar; }
        if (typeof _friendAvatars !== 'undefined' && _friendAvatars && _friendAvatars[id]) return _friendAvatars[id];
        if (window._dmAvatars && window._dmAvatars[id]) return window._dmAvatars[id];
    } catch (err) { logError('_dmAvatarFor', err); }
    return '';
}

/* ---------- Politica „cine îmi poate scrie" ---------- */
window.dmPolicyOf = function (src) {
    var e = (src && src.profileExtra && typeof src.profileExtra === 'object') ? src.profileExtra : (src && typeof src === 'object' ? src : {});
    var p = e.dmPolicy || (e.profileExtra && e.profileExtra.dmPolicy);
    return (p === 'friends' || p === 'none') ? p : 'all';
};
window.dmAreFriends = function (otherId) {
    return !!(typeof _friendsById !== 'undefined' && _friendsById[otherId] && _friendsById[otherId].status === 'accepted');
};
/* returnează {ok:bool, reason:'none'|'friends'|''} din perspectiva MEA care vreau să scriu lui `other` */
window.dmCanMessage = function (otherId, otherSrc) {
    var me = _soMe();
    if (!otherId || otherId === me) return { ok: false, reason: 'self' };
    var pol = window.dmPolicyOf(otherSrc);
    if (pol === 'all') return { ok: true, reason: '' };
    /* v9 H23 (D1): ca serverul (dm_policy_allows) — dacă persoana ți-a scris deja, îi poți
       răspunde. Memoria are doar mesajele recente: dacă nu-l găsim aici, butonul rămâne
       ascuns (prudent), iar serverul decide oricum.
       EN: like the server rule, a person who already wrote to you can always be answered. */
    if ((window._dmAll || []).some(function (d) { return d && d.sender_id === otherId && d.recipient_id === me; })) return { ok: true, reason: '' };
    if (pol === 'none') return { ok: false, reason: 'none' };
    if (pol === 'friends' && !window.dmAreFriends(otherId)) return { ok: false, reason: 'friends' };
    return { ok: true, reason: '' };
};

/* ---------- Încărcare + realtime ---------- */
/* v9 8.1-c3d: mesajele private NU mai vin toate odată.
   RO: Înainte, la pornire, la fiecare 20 s (clopoțelul) și la fiecare 4 s cu un DM
       deschis se descărcau TOATE mesajele private ale contului, din toate
       conversațiile. Acum:
       • la pornire: ultimele 200 (o singură cerere, ca înainte, dar limitată) — din
         ele vin necititele recente și lista de parteneri (redirecționarea);
       • la fiecare 20 s / la revenire: doar NECITITELE primite (clopoțelul). Ce era
         necitit în memorie și nu mai e în listă a fost citit (sau șters) pe alt
         dispozitiv ⇒ se marchează citit și aici;
       • o conversație deschisă își aduce singură ultimele 50 (`_dmConvLoad`), iar
         cele mai vechi vin la derulare (`_dmConvOlder`).
       `window._dmAll` rămâne locul unic al mesajelor din memorie; se COMPLETEAZĂ
       (`_dmUpsert`, păstrând obiectele existente), nu se mai înlocuiește.
   EN: DMs are no longer all downloaded at once: boot = latest 200, poll = unread only,
       an open conversation pages itself. */
var DM_BOOT_N = 200, DM_UNREAD_N = 500, DM_PAGE = 50;
var _dmBooted = false;
function _dmUpsert(rows) {
    if (!rows || !rows.length) return;
    var all = window._dmAll || (window._dmAll = []);
    var byId = {};
    all.forEach(function (m) { if (m && m.id != null) byId[String(m.id)] = m; });
    rows.forEach(function (r) {
        var ex = byId[String(r.id)];
        if (ex) Object.assign(ex, r); else { all.push(r); byId[String(r.id)] = r; }
    });
    all.sort(function (a, b) { return new Date(a.created_at) - new Date(b.created_at); });
}
window.loadDirectMessages = async function () {
    if (!sb || !_soMe()) return;
    try {
        var me = _soMe();
        var boot = !_dmBooted;
        /* Doar ce era deja în memorie ÎNAINTE de cerere poate fi marcat „citit în altă parte”:
           un mesaj venit în timp real cât cererea era pe drum nu e în răspuns, dar e nou. */
        var before = {};
        (window._dmAll || []).forEach(function (m) { if (m && m.id != null) before[String(m.id)] = true; });
        var res = boot
            ? await sb.from('direct_messages').select('*')
                .or('sender_id.eq.' + me + ',recipient_id.eq.' + me)
                .order('created_at', { ascending: false }).limit(DM_BOOT_N)
            : await sb.from('direct_messages').select('*')
                .eq('recipient_id', me).is('read_at', null).is('deleted_at', null)
                .order('created_at', { ascending: false }).limit(DM_UNREAD_N);
        if (res.error) throw res.error;
        if (_soMe() !== me) return;   /* contul s-a schimbat între timp */
        var rows = res.data || [];
        if (boot) {
            window._dmAll = rows.slice().reverse();
            _dmBooted = true;
        } else {
            var fresh = {};
            rows.forEach(function (r) { fresh[String(r.id)] = true; });
            /* Lista vine de la cel mai nou; dacă a fost tăiată (500), cele mai VECHI necitite
               lipsesc din ea fără să fi fost citite ⇒ sub cel mai vechi primit nu marcăm nimic. */
            var floor = rows.length >= DM_UNREAD_N ? new Date(rows[rows.length - 1].created_at).getTime() : -Infinity;
            (window._dmAll || []).forEach(function (m) {
                if (m && m.recipient_id === me && !m.read_at && before[String(m.id)] && !fresh[String(m.id)]
                    && new Date(m.created_at).getTime() >= floor) m.read_at = new Date().toISOString();
            });
            _dmUpsert(rows);
        }
        // nume pentru partenerii de conversație
        var ids = {};
        window._dmAll.forEach(function (m) {
            var other = m.sender_id === me ? m.recipient_id : m.sender_id;
            if (other) ids[other] = true;
        });
        var need = Object.keys(ids).filter(function (id) { return !window._dmNames[id]; });
        if (need.length) {
            /* v9 8.1-c1: + `avatar` (coloană publică, deja în PROFILE_COLS), pentru bara
               de sus a conversației; aceeași cerere, fără una nouă. */
            var pr = await sb.from('profiles').select('id, name, user_tag, avatar').in('id', need);
            window._dmTags = window._dmTags || {};
            window._dmAvatars = window._dmAvatars || {};
            (pr.data || []).forEach(function (p) { window._dmNames[p.id] = p.name; if (p.user_tag) window._dmTags[p.id] = p.user_tag; if (p.avatar) window._dmAvatars[p.id] = p.avatar; });
        }
    } catch (e) {
        /* ⚠ Eroarea era înghițită COMPLET, fără nicio urmă. Dacă interogarea
           eșuează (drepturi pe coloane, tabelă lipsă, filtru invalid),
           `window._dmAll` rămâne gol și mesajele private dispar din clopoțel —
           fără niciun semn în consolă că ceva n-a mers. Exact cazul „dmInMemorie: 0".
           O logăm. Nu aruncăm mai departe: o tabelă lipsă chiar nu trebuie să rupă
           aplicația, dar TREBUIE să se vadă.
           EN: this error was silently swallowed; an empty `_dmAll` looked identical
           to „no messages". Log it. */
        try { if (typeof logError === 'function') logError('loadDirectMessages', e); } catch (e2) { /* noop */ }
        try { console.warn('loadDirectMessages:', (e && (e.message || e.details || e.hint)) || e); } catch (e3) { /* noop */ }
    }
};

window.subscribeRealtimeDM = function () {
    if (!sb || !_soMe()) return;
    if (_dmChannel) { try { sb.removeChannel(_dmChannel); } catch (e) { logError('subscribeRealtimeDM.remove', e); } _dmChannel = null; }
    try {
        _dmChannel = sb.channel('dm-' + _soMe())
            .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'direct_messages' }, function (payload) {
                var msg = payload && payload.new; if (!msg) return;
                var me = _soMe();
                if (msg.sender_id !== me && msg.recipient_id !== me) return; // nu mă privește
                if (window._dmAll.some(function (x) { return x.id === msg.id; })) return;
                /* v9 8.1-s: mesajul meu încă „se trimite" ⇒ îi ia locul după codul unic */
                if (window.TO_CHAT && window.TO_CHAT.send && window.TO_CHAT.send.adopt('dm', msg)) return;
                /* ⚠ Mesajul propriu apare întâi OPTIMIST, cu `id: 'tmp_…'`. Dacă
                   realtime sosește înaintea răspunsului la `insert`, id-urile nu
                   se potrivesc și rândul se adaugă a DOUA oară — de aici bula
                   dublată pentru o secundă, la text și la poze. Îl înlocuim pe
                   cel provizoriu în loc să adăugăm unul nou.
                   Potrivirea se face pe expeditor + destinatar + conținut: un
                   mesaj provizoriu trăiește sub o secundă, deci nu există riscul
                   de a înlocui altceva.
                   EN: replace the optimistic row instead of appending a second
                       one when realtime beats the insert response. */
                var _tmpIdx = -1;
                if (msg.sender_id === me) {
                    _tmpIdx = window._dmAll.findIndex(function (x) {
                        return x && typeof x.id === 'string' && x.id.indexOf('tmp_') === 0
                            && x.sender_id === msg.sender_id && x.recipient_id === msg.recipient_id
                            && String(x.body || '') === String(msg.body || '');
                    });
                }
                if (_tmpIdx !== -1) { window._dmAll[_tmpIdx] = msg; renderDMThread(); return; }
                window._dmAll.push(msg);
                var incoming = msg.sender_id !== me;
                if (incoming) {
                    if (!window._dmNames[msg.sender_id]) {
                        sb.from('profiles').select('id, name, user_tag').eq('id', msg.sender_id).maybeSingle()
                          .then(function (r) { if (r && r.data) { window._dmNames[msg.sender_id] = r.data.name; if (r.data.user_tag) { window._dmTags = window._dmTags || {}; window._dmTags[msg.sender_id] = r.data.user_tag; } refreshDmUi(); } });
                    }
                    var nm = window._dmNames[msg.sender_id] || window.t('dm.someone');
                    if (window._dmOpenWith === msg.sender_id) {
                        renderDMThread(); markDMRead(msg.sender_id);
                    } else {
                        /* ⚠ AICI era dublarea, nu în handlerul de `notifications`.
                           Mesajele private NU trec prin tabela `notifications`, deci
                           dedublarea pe care am pus-o acolo nu le atingea deloc.
                           Același mesaj ajunge pe DOUĂ căi: toast-ul ăsta (realtime pe
                           `direct_messages`) și `showPushBanner` (push în prim-plan).
                           Cheia comună e CORPUL mesajului: push-ul trimite
                           `title = numele expeditorului`, `body = textul mesajului`, iar
                           `showPushBanner` verifică deja `payload.body` prin
                           `_notifTextAlreadyShown`. Marcăm și noi corpul BRUT (nu textul
                           compus cu „💬 nume: "), ca cele două chei să se potrivească.
                           Cine ajunge primul câștigă — userul vede exact una.
                           EN: DMs never touch the `notifications` table, so the dedup I
                           added there never applied. Shared key = the raw message body,
                           which is exactly what `showPushBanner` already checks. */
                        /* ⚠ ASIMETRIE DELIBERATĂ (corectată iulie 2026).
                           Prima versiune CONDIȚIONA acest toast de dedublare — greșit.
                           Ăsta e drumul FIABIL: vine din realtime, merge întotdeauna,
                           inclusiv cu push-ul oprit. Banner-ul de push e OPȚIONAL:
                           poate lipsi, poate întârzia, poate ajunge primul.
                           Regula corectă: NU suprimi niciodată drumul fiabil ca să faci
                           loc celui opțional. Toast-ul se afișează MEREU și doar MARCHEAZĂ
                           mesajul; `showPushBanner` verifică marcajul și se retrage el.
                           Efect: cu push oprit vezi toast-ul; cu push pornit vezi tot una
                           singură, oricare ajunge prima.
                           EN: never gate the reliable path on the optional one. This toast
                           always fires and only marks; the push banner checks and backs off. */
                        var _toast = function () {
                            /* 8.7-B4d (22 oct. 2026): același BANNER ca la chatul clubului (`showPushBanner`),
                               nu mesajul scurt din colț. Cu push-ul pornit și aplicația deschisă, DM-ul ajungea
                               pe două căi și apăreau două lucruri — bannerul push-ului ȘI mesajul scurt (care
                               intră și în „Mesaje recente"); uneori doar mesajul scurt (testul 1 din 8.7-B4, pe
                               Samsung). La club apărea mereu doar bannerul, fiindcă ambele căi îl cheamă pe el.
                               Acum la fel: aceeași funcție, aceeași cheie de dedublare (corpul brut al mesajului,
                               exact ce verifică `showPushBanner` și la push) ⇒ un singur banner, oricare cale
                               ajunge prima. Calea fiabilă (realtime) rămâne: afișează mereu, cu excepția cazului
                               în care același mesaj e deja pe ecran. Rezerva, fără `showPushBanner`: mesajul scurt.
                               EN: DMs now use the same banner as club chat, deduped with the push banner by the
                               raw body — one banner whichever path arrives first; the toast is only a fallback. */
                            if (typeof window.showPushBanner === 'function') {
                                try {
                                    window.showPushBanner({ title: nm, body: String(msg.body || ''),
                                        data: { route: 'dm', dmWith: msg.sender_id, dmName: nm, notifId: 'd' + msg.id } });
                                    return;
                                } catch (e) { logError('subscribeRealtimeDM.banner', e); }
                            }
                            try {
                                if (typeof window._notifTextAlreadyShown === 'function') window._notifTextAlreadyShown(msg.body || '');
                            } catch (e) { logError('subscribeRealtimeDM.banner', e); }
                            try { showNotification('💬 ' + nm + ': ' + String(msg.body || '').slice(0, 60), 'info'); } catch (e) { logError('subscribeRealtimeDM.toast', e); }
                        };
                        /* v9 B2b: notificările oprite de la această persoană ⇒ fără mesajul de pe
                           ecran (push-ul îl oprește deja serverul); rândul din clopoțel rămâne, ca
                           în WhatsApp. Preferințele se citesc acum dacă nu s-au citit încă.
                           EN: muted sender ⇒ no in-app toast; the bell entry stays. */
                        if (_dmPrefs) { if (!_dmPrefs.muted[msg.sender_id]) _toast(); }
                        else _dmPrefsLoad().then(function (p) { if (!(p && p.muted && p.muted[msg.sender_id])) _toast(); });
                    }
                } else if (window._dmOpenWith === msg.recipient_id) {
                    renderDMThread();
                }
                refreshDmUi();
            })
            .subscribe();
    } catch (e) { logError('subscribeRealtimeDM', e); }
};
function refreshDmUi() {
    try { if (typeof renderNotifBadge === 'function') renderNotifBadge(); } catch (e) { logError('refreshDmUi', e); }
    try { _dmSyncBlock(); } catch (e) { logError('refreshDmUi', e); }   /* v9 B2b (H24) */
}

/* ---------- Realtime: prietenii + cereri de aderare (instant, ca la chat) ---------- */
var _socialChannel = null;
window.subscribeRealtimeSocial = function () {
    if (!sb || !_soMe()) return;
    if (_socialChannel) { try { sb.removeChannel(_socialChannel); } catch (e) { logError('refreshDmUi', e); } _socialChannel = null; }
    try {
        _socialChannel = sb.channel('social-' + _soMe())
            .on('postgres_changes', { event: '*', schema: 'public', table: 'friendships' }, function (payload) {
                var me = _soMe();
                /* ⚠ DEFECTUL REPARAT — „Acceptă" se propaga instant, „Șterge prietenia" nu.
                     Codul vechi făcea `payload.new || payload.old`. La DELETE, Supabase
                     trimite `new: {}` — obiect GOL, dar ADEVĂRAT LOGIC — deci `||` se
                     oprea la el și nu ajungea NICIODATĂ la `payload.old`. Rezultat:
                     `requester_id`/`addressee_id` `undefined`, filtrul de mai jos ieșea,
                     iar celălalt cont nu afla nimic. La UPDATE `payload.new` e plin, de
                     aceea acceptarea funcționa — exact asimetria raportată.
                   ⚠ NU e o problemă de `replica identity`: tabela era deja pe `full`,
                     iar coloanele CHIAR erau în `payload.old`. Se alegea greșit sursa.
                   ⚠ Alegem rândul care are CONȚINUT, nu primul care e adevărat logic.
                     Așa se păstrează și filtrul „ștergerile altora nu mă privesc".
                   ⚠ Dacă niciunul nu are conținut (replica identity slabă pe viitor),
                     reîncărcăm oricum la DELETE: `loadFriendData` e scopată prin RLS,
                     deci o reîncărcare în plus e ieftină și nu scurge nimic.
                   EN: on DELETE, `payload.new` is an EMPTY BUT TRUTHY object, so `||`
                       never fell through to `payload.old`. Pick the row that actually
                       has content. */
                var _has = function (r) { return !!(r && (r.requester_id != null || r.addressee_id != null)); };
                var row = _has(payload && payload.new) ? payload.new
                        : (_has(payload && payload.old) ? payload.old : null);
                if (row) { if (row.requester_id !== me && row.addressee_id !== me) return; }
                else if (!(payload && payload.eventType === 'DELETE')) return;
                var incoming = payload.eventType === 'INSERT' && payload.new && payload.new.addressee_id === me && payload.new.status === 'pending';
                if (typeof loadFriendData === 'function') {
                    loadFriendData().then(function () {
                        try { if (typeof renderNotifBadge === 'function') renderNotifBadge(); } catch (e) { logError('refreshDmUi', e); }
                        try { if (typeof window.refreshFriendsUi === 'function') window.refreshFriendsUi(); } catch (e) { logError('refreshDmUi', e); }
                        if (incoming) {
                            var nm = (typeof _friendNames !== 'undefined' && _friendNames[payload.new.requester_id]) || window.t('dm.someone');
                            /* 26 oct. 2026 (raportat de Alex): cu aplicația deschisă apăreau DOUĂ mesaje, unul
                               peste altul — acesta și bannerul notificării push. Ca la DM (8.7-B4d): aceeași bară
                               ca la push, cu același id (`fr<cel care trimite>`, V9_87F2) și același text, deci
                               al doilea venit nu mai apare. EN: same banner + id as the push ⇒ shown once. */
                            try {
                                if (typeof window.showPushBanner === 'function') {
                                    window.showPushBanner({ title: nm, body: '👋 ' + window.t('friend.reqPush'),
                                        data: { notifId: 'fr' + payload.new.requester_id, route: 'friendreq', profileId: payload.new.requester_id } });
                                } else showNotification('👋 ' + nm + ' ' + window.t('notif.friendReq'), 'info');
                            } catch (e) { logError('refreshDmUi', e); }
                        }
                    });
                }
            })
            .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'club_join_requests' }, function (payload) {
                var row = payload && payload.new; if (!row) return;
                var adminIds = (state.myClubs || []).filter(function (c) { return c.myRole === 'principal_admin' || c.myRole === 'secondary_admin'; }).map(function (c) { return c.id; });
                if (adminIds.indexOf(row.club_id) === -1) return;
                try { if (typeof refreshPendingBadge === 'function') refreshPendingBadge(); } catch (e) { logError('refreshDmUi', e); }
                if (typeof loadAllNotifications === 'function') loadAllNotifications().then(function () { try { renderNotifBadge(); } catch (e) { logError('refreshDmUi', e); } });
                try { showNotification('📩 ' + window.t('notif.joinReqToast'), 'info'); } catch (e) { logError('refreshDmUi', e); }
            })
            .subscribe();
    } catch (e) { logError('refreshDmUi', e); }
};
window.unsubscribeRealtimeSocial = function () {
    if (_socialChannel) { try { sb.removeChannel(_socialChannel); } catch (e) { logError('refreshDmUi', e); } _socialChannel = null; }
    if (_dmChannel) { try { sb.removeChannel(_dmChannel); } catch (e) { logError('refreshDmUi', e); } _dmChannel = null; }
};

/* ---------- Integrare în centrul de notificări ---------- */
window.getDmNotifItems = function () {
    var me = _soMe(); if (!me) return [];
    /* ⚠ H20 (v9): „primit" = trimis CATRE mine, nu doar „netrimis de mine". Daca in
       memorie au ramas randuri din contul anterior (logout fara reincarcare), vechiul
       filtru le arata in clopotelul noului cont. EN: received = addressed TO me. */
    /* v9 B2a: + fără mesajele șterse (altfel rămânea în clopoțel un rând „Nume: " gol). */
    return (window._dmAll || []).filter(function (m) { return m.sender_id !== me && m.recipient_id === me && !m.read_at && !m.deleted_at; })
        .map(function (m) {
            var nm = window._dmNames[m.sender_id] || window.t('dm.someone');
            /* ⚠ Un mesaj DOAR cu poze are `body` gol (coloana e NOT NULL, deci ''),
               iar notificarea ar fi apărut ca „Nume: " — un rând care nu spune
               nimic. Punem o etichetă în locul textului lipsă. */
            var _corp = String(m.body || '');
            if (!_corp && Array.isArray(m.photos) && m.photos.length) _corp = window.t('dm.photoOnly');
            var prev = _corp.slice(0, 60);
            return { id: 'dm' + m.id, ts: new Date(m.created_at).getTime(), icon: 'fa-envelope',
                     text: nm + ': ' + prev + (_corp.length > 60 ? '…' : ''),
                     dmWith: m.sender_id, dmName: nm };
        });
};
window.openDMFromNotif = function (otherId, name, notifId) {
    try { var panel = document.getElementById('notifPanel'); if (panel) panel.classList.add('hidden'); } catch (e) { logError('refreshDmUi', e); }
    if (notifId && typeof getSeenIds === 'function') { var s = getSeenIds() || new Set(); s.add(notifId); saveSeenIds(s); }
    window.openDM(otherId, name);
};

/* Notificări pentru cereri de prietenie primite (în așteptare) */
window.getFriendNotifItems = function () {
    if (typeof _friendsById === 'undefined' || !_friendsById) return [];
    var FN = (typeof _friendNames !== 'undefined' && _friendNames) || {};
    var out = [];
    Object.keys(_friendsById).forEach(function (id) {
        var f = _friendsById[id];
        if (f && f.status === 'pending' && f.dir === 'in') {
            var nm = FN[id] || window.t('dm.someone');
            out.push({ id: 'fr' + id, ts: f.ts || Date.now(), icon: 'fa-user-plus',
                       text: nm + ' ' + window.t('notif.friendReq'), profileId: id, profileName: nm });
        }
    });
    return out;
};
window.openFriendReqNotif = function (profileId, name, notifId) {
    try { var panel = document.getElementById('notifPanel'); if (panel) panel.classList.add('hidden'); } catch (e) { logError('refreshDmUi', e); }
    if (notifId && typeof getSeenIds === 'function') { var s = getSeenIds() || new Set(); s.add(notifId); saveSeenIds(s); }
    window.openPublicProfileById(profileId, name);
};

/* ---------- Poll periodic: notificări „live" chiar și fără realtime ---------- */
var _notifPollTimer = null;
function _notifRefreshAll() {
    if (!sb || !_soMe()) return Promise.resolve();
    return Promise.all([
        (typeof loadFriendData === 'function') ? loadFriendData() : null,
        (typeof window.loadDirectMessages === 'function') ? window.loadDirectMessages() : null,
        (typeof loadAllNotifications === 'function') ? loadAllNotifications() : null
    ]).then(function () { try { if (typeof renderNotifBadge === 'function') renderNotifBadge(); } catch (e) { logError('_notifRefreshAll', e); } try { if (typeof window.refreshFriendsUi === 'function') window.refreshFriendsUi(); } catch (e) { logError('_notifRefreshAll', e); } }).catch(function () {});
}
window.notifPollStart = function () {
    window.notifPollStop();
    if (!sb || !_soMe()) return;
    _notifPollTimer = setInterval(function () { if (!document.hidden) _notifRefreshAll(); }, 20000);
    if (!window._notifVisBound) {
        window._notifVisBound = true;
        document.addEventListener('visibilitychange', function () { if (!document.hidden) _notifRefreshAll(); });
    }
};
window.notifPollStop = function () { if (_notifPollTimer) { clearInterval(_notifPollTimer); _notifPollTimer = null; } };

/* ---------- v9 B2b: preferințele conversațiilor private ----------
   RO: Pe server (B1b): `dm_hidden` („Șterge conversația" doar pentru mine: mesajele de
       până la `hidden_before` nu se mai arată) și `dm_mutes` (notificări oprite de la o
       persoană; push-ul îl oprește serverul). Fiecare își citește doar rândurile lui
       (RLS) și le scrie doar prin funcțiile serverului.
       • Citite LENEȘ, o singură dată pe sesiune: la primul DM deschis sau la primul
         mesaj privat primit cât aplicația e deschisă — nu la pornire (nicio cerere nouă
         în `onAuthenticated`). Două cereri mici, în paralel.
       • Doar în memorie; golite la schimbarea contului (`dmResetState`).
       • O eroare NU se ține minte: următoarea deschidere reîncearcă. Până atunci
         conversația se vede întreagă (datele sunt oricum ale tale).
   EN: lazily loaded per session (first DM open / first incoming DM), memory only,
       cleared on account switch; failures are retried, not cached. */
var _dmPrefs = null, _dmPrefsBusy = null;
function _dmPrefsLoad() {
    if (_dmPrefs) return Promise.resolve(_dmPrefs);
    if (_dmPrefsBusy) return _dmPrefsBusy;
    var me = _soMe();
    if (typeof isDemoMode === 'function' && isDemoMode()) { _dmPrefs = { hidden: {}, muted: {} }; return Promise.resolve(_dmPrefs); }   /* demo: zero trafic */
    if (!sb || !me) return Promise.resolve({ hidden: {}, muted: {} });
    _dmPrefsBusy = Promise.all([
        sb.from('dm_hidden').select('other_id, hidden_before').eq('user_id', me),
        sb.from('dm_mutes').select('other_id').eq('user_id', me)
    ]).then(function (rs) {
        if (rs[0].error || rs[1].error) throw (rs[0].error || rs[1].error);
        var p = { hidden: {}, muted: {} };
        (rs[0].data || []).forEach(function (r) { p.hidden[r.other_id] = r.hidden_before; });
        (rs[1].data || []).forEach(function (r) { p.muted[r.other_id] = true; });
        if (_soMe() === me) _dmPrefs = p;   /* contul s-a schimbat între timp ⇒ nu păstrăm */
        return p;
    }).catch(function (e) {
        logError('dmPrefsLoad', e);
        return { hidden: {}, muted: {} };
    }).then(function (p) { _dmPrefsBusy = null; return p; });
    return _dmPrefsBusy;
}

/* ---------- Conversație DM ---------- */
/* v9 B2b: + fără mesajele de dinainte de „Șterge conversația" (doar la tine). */
window.dmConversation = function (otherId) {
    var me = _soMe();
    var hb = (_dmPrefs && _dmPrefs.hidden[otherId]) ? new Date(_dmPrefs.hidden[otherId]).getTime() : 0;
    return (window._dmAll || []).filter(function (m) {
        return ((m.sender_id === me && m.recipient_id === otherId) || (m.sender_id === otherId && m.recipient_id === me))
            && (!hb || new Date(m.created_at).getTime() > hb);
    }).sort(function (a, b) { return new Date(a.created_at) - new Date(b.created_at); });
};

/* ---------- v9 8.1-c3b: o conversație își aduce singură mesajele ----------
   RO: • `_dmConvLoad(id)`: ultimele 50 ale conversației (la deschidere, la fiecare 4 s
         cât e deschisă, la revenirea în aplicație). Ce lipsește din răspuns, în
         intervalul adus, a fost scos de pe server (ex. moderare) ⇒ se scoate și aici;
         mesajele mai noi decât răspunsul (venite între timp) rămân.
       • `_dmConvOlder(id)`: la derularea în sus, încă 50 (`lte` + fără dubluri, ca în
         club), până la începutul conversației sau până la „Șterge conversația".
       • `_dmSearchServer(id, q)`: căutarea în toată conversația, pe server
         (`search_dm_messages`, V9_C3S_CAUTARE.sql), după o pauză de 300 ms; un
         răspuns pentru un text deja schimbat se ignoră.
       • Demo: zero trafic (doar memoria).
   EN: per-conversation loading (latest 50, older pages, server search). */
var _dmConv = {};
var _dmSrv = { key: '', rows: null, pending: false, seq: 0, timer: 0 };
function _dmIsDemo() { return typeof isDemoMode === 'function' && isDemoMode(); }
function _dmPairOr(me, other) {
    return 'and(sender_id.eq.' + me + ',recipient_id.eq.' + other + '),and(sender_id.eq.' + other + ',recipient_id.eq.' + me + ')';
}
function _dmInPair(m, me, other) {
    return !!m && ((m.sender_id === me && m.recipient_id === other) || (m.sender_id === other && m.recipient_id === me));
}
function _dmConvLoad(otherId) {
    var me = _soMe();
    if (!sb || !me || !otherId || _dmIsDemo()) return Promise.resolve();
    var st = _dmConv[otherId] || (_dmConv[otherId] = { loaded: false, end: false, busy: null, older: null });
    if (st.busy) return st.busy;
    st.busy = sb.from('direct_messages').select('*').or(_dmPairOr(me, otherId))
        .order('created_at', { ascending: false }).limit(DM_PAGE)
        .then(function (r) {
            if (r.error) throw r.error;
            if (_soMe() !== me) return;
            var rows = r.data || [];
            var got = {};
            rows.forEach(function (x) { got[String(x.id)] = true; });
            var lo = rows.length ? new Date(rows[rows.length - 1].created_at).getTime() : -Infinity;
            var hi = rows.length ? new Date(rows[0].created_at).getTime() : Infinity;
            /* conversație mai scurtă de o pagină ⇒ tot ce lipsește din răspuns a dispărut */
            if (rows.length < DM_PAGE) lo = -Infinity;
            window._dmAll = (window._dmAll || []).filter(function (m) {
                if (!_dmInPair(m, me, otherId) || typeof m.id === 'string' || got[String(m.id)]) return true;
                var t = new Date(m.created_at).getTime();
                return !(t >= lo && t <= hi);
            });
            _dmUpsert(rows);
            if (!st.loaded) { st.loaded = true; st.end = rows.length < DM_PAGE; }
        })
        .catch(function (e) { logError('dmConvLoad', e); })
        .then(function () { st.busy = null; });
    return st.busy;
}
function _dmConvOlder(otherId) {
    var me = _soMe(), st = _dmConv[otherId];
    if (!st || !st.loaded || st.end || st.older || !sb || !me || _dmIsDemo()) return null;
    var pair = (window._dmAll || []).filter(function (m) { return _dmInPair(m, me, otherId) && typeof m.id !== 'string'; });
    var oldest = pair[0];
    if (!oldest) { st.end = true; return null; }
    var hb = (_dmPrefs && _dmPrefs.hidden[otherId]) ? new Date(_dmPrefs.hidden[otherId]).getTime() : 0;
    if (hb && new Date(oldest.created_at).getTime() <= hb) { st.end = true; return null; }   /* dincolo e „șters pentru mine" */
    var box = document.getElementById('dmThread');
    st.older = sb.from('direct_messages').select('*').or(_dmPairOr(me, otherId))
        .lte('created_at', oldest.created_at)
        .order('created_at', { ascending: false }).limit(DM_PAGE + 1)
        .then(function (r) {
            if (r.error) throw r.error;
            if (_soMe() !== me || window._dmOpenWith !== otherId) return;
            var have = {};
            pair.forEach(function (m) { have[String(m.id)] = true; });
            var rows = (r.data || []).filter(function (x) { return !have[String(x.id)]; });
            if ((r.data || []).length < DM_PAGE + 1 || !rows.length) st.end = true;
            if (!rows.length) return;
            /* ce citeai rămâne pe loc: ancoră pe primul mesaj vizibil */
            var anchor = null, before = 0;
            if (box) {
                var top = box.getBoundingClientRect().top;
                anchor = [].find.call(box.querySelectorAll('.dm-msg'), function (el) { return el.getBoundingClientRect().bottom > top + 1; }) || null;
                if (anchor) before = anchor.getBoundingClientRect().top;
            }
            _dmUpsert(rows);
            renderDMThread();
            if (anchor && box) {
                var again = document.getElementById(anchor.id);
                if (again) { var d = again.getBoundingClientRect().top - before; if (d) box.scrollTop += d; }
            }
        })
        .catch(function (e) { logError('dmConvOlder', e); })
        .then(function () { st.older = null; });
    return st.older;
}
function _dmSearchServer(otherId, q) {
    q = String(q || '').trim();
    var key = (otherId || '') + '|' + q.toLowerCase();
    if (key === _dmSrv.key) return;
    _dmSrv.key = key; _dmSrv.rows = null; _dmSrv.pending = false;
    var my = ++_dmSrv.seq;
    clearTimeout(_dmSrv.timer);
    if (q.length < 2 || !otherId || !sb || !_soMe() || _dmIsDemo()) return;
    _dmSrv.pending = true;
    _dmSrv.timer = setTimeout(function () {
        sb.rpc('search_dm_messages', { p_other: otherId, p_q: q }).then(function (r) {
            if (my !== _dmSrv.seq) return;
            _dmSrv.pending = false;
            if (r.error) { if (!(window.TO_CHAT && window.TO_CHAT.msg && window.TO_CHAT.msg.rpcMissing(r.error))) logError('dmSearch', r.error); }
            else _dmSrv.rows = r.data || [];
            if (window._dmOpenWith === otherId) renderDMThread();
        }, function (e) { if (my === _dmSrv.seq) { _dmSrv.pending = false; logError('dmSearch', e); } });
    }, 300);
}
function _dmSearchRows(otherId, q) {
    return ((otherId || '') + '|' + String(q || '').trim().toLowerCase() === _dmSrv.key) ? _dmSrv.rows : null;
}
/* 8.1-c3b: bara „N mesaje necitite" din DM pornește de la PRIMUL necitit, chiar dacă e
   mai vechi decât ce e în memorie. Defect văzut de Alex: 120 necitite, bara arăta 101,
   de la al 21-lea (în memorie erau doar cele din ultimele 200 ale contului). Dacă cel
   mai vechi mesaj din memorie al conversației e încă necitit, cerem serverului primul
   necitit și numărul lor (o cerere, cu `count`), apoi mesajele dintre el și memorie
   (cel mult 1000). Altfel: nicio cerere. EN: unread bar starts at the real first unread. */
function _dmUnreadRecalc(otherId, total) {
    var un = (window.dmConversation(otherId) || []).filter(function (m) { return m.sender_id === otherId && !m.read_at && !m.deleted_at; });
    window._dmUnread = un.length ? { id: String(un[0].id), n: Math.max(total || 0, un.length) } : null;
}
function _dmUnreadGap(otherId) {
    var me = _soMe();
    var pair = (window._dmAll || []).filter(function (m) { return _dmInPair(m, me, otherId) && typeof m.id !== 'string'; });
    var oldest = pair[0];
    if (!sb || !me || _dmIsDemo() || !oldest || oldest.sender_id !== otherId || oldest.read_at || oldest.deleted_at) {
        _dmUnreadRecalc(otherId, 0);
        return Promise.resolve();
    }
    return sb.from('direct_messages').select('id, created_at', { count: 'exact' })
        .eq('sender_id', otherId).eq('recipient_id', me).is('read_at', null).is('deleted_at', null)
        .order('created_at', { ascending: true }).limit(1)
        .then(function (r) {
            if (r.error) throw r.error;
            var first = (r.data || [])[0], total = r.count || 0;
            if (!first || new Date(first.created_at) >= new Date(oldest.created_at)) return total;
            return sb.from('direct_messages').select('*').or(_dmPairOr(me, otherId))
                .gte('created_at', first.created_at).lt('created_at', oldest.created_at)
                .order('created_at', { ascending: false }).limit(1000)
                .then(function (r2) { if (r2.error) throw r2.error; if (_soMe() === me) _dmUpsert(r2.data || []); return total; });
        })
        .then(function (total) { _dmUnreadRecalc(otherId, total); }, function (e) { logError('dmUnreadGap', e); _dmUnreadRecalc(otherId, 0); });
}
/* v9 8.13-4a (28 oct. 2026): ECRANUL conversației private (openDM, renderDMThread, sendDM,
   pozele, meniul mesajului, editare / ștergere / info și reîmprospătarea la revenire) a fost
   MUTAT identic în chat-dm.js. EN: moved to chat-dm.js.
   ── 8.13-4b (29 oct. 2026): PUNTEA spre chat-dm.js, încărcat LA CERERE ────────────────────
   RO: chat-dm.js nu mai e la pornire (−33 kB minificat). Cele 8 nume chemate din afară
       (alte fișiere, handlere inline, Realtime-ul de mai sus) sunt definite O SINGURĂ DATĂ,
       aici; implementarea e pe `window.TO_DM`:
       • „deschid" (openDM, dmScrollToMessage, dmSetReply): încarcă fișierul dacă trebuie
         (`TO_CHAT.useModule`, cu verificarea versiunii), apoi cheamă;
       • „actualizează" (renderDMThread, markDMRead, closeDM, _dmSyncBlock): fără fișier nu
         există niciun DM pe ecran ⇒ nimic de făcut (înainte, un mesaj sosit prin Realtime
         ar fi aruncat ReferenceError);
       • `dmResetState` (H20): golește MEREU datele DM-urilor la ieșirea din cont și, dacă
         fișierul e încărcat, întâi ecranul (`TO_DM.resetScreen`) — altfel mesajele contului
         vechi ar rămâne în memorie.
       Fișierul se încarcă singur în timp liber, la ~4 s după pornire (doar cu cont), ca prima
       deschidere a unui DM să fie la fel de rapidă ca înainte.
   EN: bridge to the lazily loaded chat-dm.js: openers load then call, updaters no-op until
       loaded, the logout reset always clears DM data; idle warm-up ~4 s after start. */
(function () {
    var FILE = 'chat-dm.js', NAME = 'TO_DM';
    /* ⚠ Doar dacă ștampila e a paginii: după un deploy, fișierul NOU refuzat de încărcător
       (versiune amestecată ⇒ „Reîncarcă?") rămâne totuși în pagină; fără verificarea asta,
       al doilea clic l-ar fi folosit direct (verificat în browser, 29 oct.).
       EN: use TO_DM only when its stamp matches the page release. */
    function mod() {
        var M = window.TO_DM, rel = (typeof window.TO_RELEASE === 'string') ? window.TO_RELEASE : '';
        return (M && typeof M.openDM === 'function' && (!rel || M.stamp === rel)) ? M : null;
    }
    function load(quiet) {
        if (!window.TO_CHAT || typeof window.TO_CHAT.useModule !== 'function') return Promise.resolve(null);
        return window.TO_CHAT.useModule(FILE, NAME, null, quiet);
    }
    function opener(key) {
        return function () {
            var M = mod(), a = arguments, self = this;
            if (M) return M[key].apply(self, a);
            return load(false).then(function (M2) { if (M2 && typeof M2[key] === 'function') return M2[key].apply(self, a); });
        };
    }
    function updater(key) {
        return function () { var M = mod(); if (M) return M[key].apply(this, arguments); };
    }
    window.openDM = opener('openDM');
    window.dmScrollToMessage = opener('dmScrollToMessage');
    window.dmSetReply = opener('dmSetReply');
    window.renderDMThread = updater('renderDMThread');
    window.markDMRead = updater('markDMRead');
    window.closeDM = updater('closeDM');
    window._dmSyncBlock = updater('_dmSyncBlock');
    window.dmResetState = function () {
        var M = mod();
        if (M) { try { M.resetScreen(); } catch (e) { logError('dmResetState', e); } }
        window._dmAll = [];
        window._dmNames = {};
        window._dmTags = {};
        window._dmAvatars = {};
        _dmPrefs = null; _dmPrefsBusy = null;   /* v9 B2b: conversații ascunse + notificări oprite */
        _dmBooted = false; _dmConv = {}; clearTimeout(_dmSrv.timer); _dmSrv = { key: '', rows: null, pending: false, seq: 0, timer: 0 };   /* v9 8.1-c3 */
    };
    try {
        setTimeout(function () {
            var go = function () {
                if (mod() || typeof state === 'undefined' || !state || !state.currentUser) return;
                load(true);
            };
            if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(go, { timeout: 3000 }); else go();
        }, 4000);
    } catch (e) { logError('dmWarm', e); }
})();


/* ---------- Buton „Trimite mesaj" pentru modalul de profil ---------- */
window.dmButtonHtml = function (otherId, otherName, otherSrc) {
    var chk = window.dmCanMessage(otherId, otherSrc);
    if (chk.reason === 'self') return '';
    if (chk.ok) {
        /* v9 S-1 (28 oct. 2026): numele afișat stătea într-un handler inline, cu apostroful
           escapat, dar NU și backslash-ul ⇒ un nume care conține backslash + apostrof ieșea din
           șir și rula cod la apăsare (dovedit în jsdom pe `655f0bc`). Acum id-ul și numele stau
           în `data-*`, escapate pentru HTML (`dataset` le întoarce exact), iar clicul îl prinde
           delegarea de mai jos. EN: id and name moved from an inline handler into HTML-escaped
           data-* attributes; an unescaped backslash let a display name run code. */
        return '<button class="btn btn-sm" style="width:auto; min-width:auto; padding:8px 14px;" data-action="dm-open" data-uid="' + _soEsc(String(otherId)) + '" data-name="' + _soEsc(String(otherName || '')) + '"><i class="fas fa-paper-plane"></i> ' + window.t('dm.send') + '</button>';
    }
    var note = chk.reason === 'none' ? window.t('dm.policyNone') : window.t('dm.policyFriends');
    return '<span style="font-size:0.78em; color:var(--text-secondary);"><i class="fas fa-comment-slash"></i> ' + note + '</span>';
};
/* Delegarea pentru butonul de mai sus (profilul public și rândul de acțiuni din `block.js`)
   și pentru iconița „Istoric nume" de mai jos (S-1b).
   Pe CAPTURĂ, ca la „Refuză / Anulează" de mai jos: un strămoș care oprește propagarea nu
   mai poate omorî butonul. NU oprim propagarea și nu anulăm acțiunea implicită — exact ca
   handlerul inline de dinainte, ca restul ascultătorilor să vadă același clic.
   EN: capture-phase delegation, no stopPropagation, same effect as the old inline handlers. */
(function () {
    try {
        document.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-action="dm-open"], [data-action="namehist"]') : null;
            if (!b) return;
            if (b.getAttribute('data-action') === 'namehist') { window.showNameHistory(b.getAttribute('data-key')); return; }
            closeAnyModalSafe();
            window.openDM(b.getAttribute('data-uid'), b.getAttribute('data-name') || '');
        }, true);
    } catch (e) { logError('dmOpenBtn', e); }
})();
function closeAnyModalSafe() {
    // închide modalul de profil (dar nu DM-ul nou)
    var pm = document.getElementById('publicProfileModal'); if (pm) pm.remove();
}
window.closeAnyModalSafe = closeAnyModalSafe;

/* ---------- Istoric nume afișat ---------- */
window._nameHistCache = {};
window.profileNameHistoryIcon = function (idKey, profileExtra) {
    var hist = (profileExtra && Array.isArray(profileExtra.nameHistory)) ? profileExtra.nameHistory.filter(Boolean) : [];
    if (!hist.length) return '';
    window._nameHistCache[idKey] = hist;
    /* v9 S-1b (28 oct. 2026): aceeași escapare incompletă ca la butonul „Trimite mesaj"
       (`idKey` = id-ul SAU numele, când lipsește id-ul) ⇒ cheia stă în `data-key`, clicul
       îl prinde delegarea de lângă `dmButtonHtml`. EN: same fix as the DM button. */
    return ' <i class="fas fa-circle-info" title="' + window.t('namehist.title') + '" style="cursor:pointer; color:var(--text-secondary); font-size:0.7em; vertical-align:middle;" data-action="namehist" data-key="' + _soEsc(String(idKey)) + '"></i>';
};
window.showNameHistory = function (idKey) {
    var hist = window._nameHistCache[idKey] || [];
    var existing = document.getElementById('nameHistModal'); if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.className = 'modal active'; modal.id = 'nameHistModal';
    if (modal.dataset) modal.dataset.dynamic = '1';
    modal.onclick = function (e) { if (e.target === modal) modal.remove(); };
    var list = hist.length ? hist.map(function (n) { return '<li style="padding:4px 0;">' + _soEsc(n) + '</li>'; }).join('') : '<li>—</li>';
    modal.innerHTML = '<div class="modal-content" style="max-width:380px;">'
        + '<div class="modal-header"><h2><i class="fas fa-clock-rotate-left"></i> ' + window.t('namehist.title') + '</h2>'
        + '<button class="modal-close">×</button></div>'
        + '<p style="color:var(--text-secondary); font-size:0.85em; margin-bottom:8px;">' + window.t('namehist.intro') + '</p>'
        + '<ul style="margin:0; padding-left:18px;">' + list + '</ul></div>';
    /* ✕ fără handler inline (regula „zero onclick=" în zona atinsă): același efect. */
    modal.querySelector('.modal-close').addEventListener('click', function () { modal.remove(); });
    document.body.appendChild(modal);
};

/* ---------- Profil public (clicabil) ---------- */
window.openPublicProfile = async function (p) {
    if (!p) return;
    var id = p.id || p.dbId;
    var name = p.name || '';
    var avatar = p.avatar || '';

    /* §7: statisticile GLOBALE trebuie să fie în cache ÎNAINTE de paint, altfel
       profileExperienceLevel cade pe fallback-ul „doar clubul curent" -> nivel greșit.
       Fetch doar dacă lipsesc (de regulă instant, fără request). */
    if (id && typeof window.ensurePlayerStats === 'function') {
        try { await window.ensurePlayerStats([id]); } catch (e) { /* nivelul cade pe fallback */ }
    }

    var existing = document.getElementById('publicProfileModal'); if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.className = 'modal active'; modal.id = 'publicProfileModal';
    if (modal.dataset) modal.dataset.dynamic = '1';
    modal.onclick = function (e) { if (e.target === modal) modal.remove(); };

    var avatarHtmlFn = (typeof avatarHtml === 'function') ? avatarHtml : function (a, s) { return ''; };
    var userTag = p.userTag || p.user_tag || '';
    /* ⚠ Când relația e blocată rămân doar NUMELE și STATISTICILE. Emailul e dată
         cu caracter personal: a rămâne vizibil în profilul cuiva pe care l-ai
         blocat (sau care te-a blocat) e cel mai grav dintre detaliile scăpate.
         Se ascunde ÎNAINTE de a intra în HTML, nu prin CSS. */
    var _blocat = (typeof window.isBlockedPair === 'function' && id) ? window.isBlockedPair(id) : false;
    /* ⚠ 9.6: `p.email` venea din `profiles.email`, coloană care NU mai e livrată clientului
       — deci aici scria „Email ascuns" pentru toată lumea. Acum întrebăm sursa unică; ce
       primim de acolo a trecut deja prin verificările serverului. Blocarea rămâne o
       interdicție în plus. EN: p.email was always undefined; use the single source. */
    var _emVis = p.email || ((typeof window.visibleEmailOf === 'function' && id) ? window.visibleEmailOf(id) : null);
    var emailLine = (!_blocat && _emVis) ? _soEsc(_emVis) : window.t('profile.emailHidden');
    /* CRITIC (§7): pasăm și `id`-ul. Fără el, profileExperienceLevel primea doar NUMELE,
       nu-l putea rezolva la profile_id, nu găsea statisticile globale și compara numele
       cu `participants` (care sunt id-uri) -> 0 meciuri -> nivel complet greșit. */
    var memberLike = { id: id, dbId: id, name: name, profileExtra: p.profileExtra || p.profile_extra || null };
    var publicFields = (typeof window.profileRenderPublic === 'function') ? window.profileRenderPublic(memberLike) : '';
    /* 26 oct. 2026 (raportat de Alex): pe PROPRIUL profil apărea „Adaugă prieten" — era singurul
       buton fără gardă pe ramura de rezervă de mai jos (mesajul și raportarea o au), iar serverul
       refuza cererea („nu ai permisiune"). EN: no friend button on your own profile. */
    var friendBtn = (typeof _friendBtnHtml === 'function' && id && id !== _soMe()) ? _friendBtnHtml({ id: id }) : '';
    var dmBtn = id ? window.dmButtonHtml(id, name, memberLike) : '';
    var reportBtn = (id && id !== _soMe() && typeof window.userMenuBtn === 'function')
        ? window.userMenuBtn(id)
        : (id && id !== _soMe() && typeof window.reportIconBtn === 'function')
        ? window.reportIconBtn('user', id)
        : '';
    var ppActs = (typeof window.userActionsHtml === 'function' && id && id !== _soMe())
        ? window.userActionsHtml(id, { name: name, member: memberLike })
        : (dmBtn + ' ' + friendBtn + ' ' + reportBtn);

    /* Jocuri preferate — aceleași carduri (titlu peste imagine) ca peste tot, cu respectarea vizibilității. */
    var favVis = !(memberLike.profileExtra && memberLike.profileExtra.vis && memberLike.profileExtra.vis.favGames === false);
    var favList = (favVis && Array.isArray(p.preferred_games)) ? p.preferred_games : [];
    var favHtml = (favList.length && typeof window.favCardsHtml === 'function')
        ? '<div style="margin-bottom:10px;"><strong>' + window.t('profile.favGames') + ':</strong><div style="margin-top:6px;">'
            + window.favCardsHtml(favList, (memberLike.profileExtra && memberLike.profileExtra.favGameImages) || {}, { key: 'fav-' + (id || name), heading: window.t('profile.favGames') }) + '</div></div>'
        : '';

    /* BGG + cluburi publice (mutate aici din cardul de Discover ca să fie totul într-un loc). */
    var bggHtml = (p.bgg_username && !_blocat)
        ? '<p style="margin-bottom:8px;"><strong>BoardGameGeek:</strong> <a href="https://boardgamegeek.com/user/' + encodeURIComponent(p.bgg_username) + '" target="_blank" rel="noopener" style="color:var(--accent-primary);"><i class="fas fa-dice"></i> ' + _soEsc(p.bgg_username) + '</a></p>'
        : '';
    var clubsArr = Array.isArray(p.clubs) ? p.clubs : [];
    var clubsHtml = clubsArr.length
        ? '<div style="margin-bottom:10px;"><strong>' + window.t('profile.clubs') + ':</strong><div style="display:flex; flex-wrap:wrap; gap:6px; margin-top:6px;">'
            + clubsArr.slice(0, 12).map(function (cn) { return '<span style="font-size:0.78em; background:rgba(255,255,255,0.08); border-radius:8px; padding:3px 10px;"><i class="fas fa-layer-group" style="opacity:.6;"></i> ' + _soEsc(cn) + '</span>'; }).join('')
            + '</div></div>'
        : '';

    /* Spațiu fizic (Discover „pașaport") — respectă strict vizibilitatea (deja gated de RPC). */
    var spaceHtml = (p.space && !_blocat && typeof window.profileSpacePublicHtml === 'function') ? window.profileSpacePublicHtml(p.space) : '';

    /* v9 8.14: punctul online pe avatar (presence.js), urmărit cât e deschis profilul; nimic
       la relație blocată sau în propriul profil. 8.14-b: fără a doua linie „● Online" (dublura
       văzută de Alex). EN: online dot on the avatar while the profile is open. */
    var _ppOk = !!(id && id !== _soMe() && !_blocat && window.TO_PRES);
    var _ppId = _ppOk ? window.escHtml(String(id)) : '';
    var _ppDot = _ppOk ? '<span class="presence-dot" aria-hidden="true" data-pres-id="' + _ppId + '"></span>' : '';
    modal.innerHTML =
        '<div class="modal-content" style="max-width:520px;">'
        + '<div class="modal-header">'
        +   '<h2><i class="fas fa-id-card"></i> ' + window.t('profile.playerProfile') + '</h2>'
        +   '<button class="modal-close" onclick="this.closest(\'.modal\').remove()">×</button>'
        + '</div>'
        + '<div style="display:flex; align-items:center; gap:14px; margin-bottom:14px;">'
        +   '<div class="pres-av" style="line-height:1;"' + (_ppOk ? ' data-pres-watch="' + _ppId + '"' : '') + '>' + ((typeof window.blockAvatarHtml === 'function' && id) ? window.blockAvatarHtml(avatar, 64, id) : avatarHtmlFn(avatar, 64)) + _ppDot + '</div>'
        +   '<div><div style="font-size:1.3em; font-weight:700;">' + _soEsc(name) + (typeof window.profileNameHistoryIcon === 'function' ? window.profileNameHistoryIcon(id || name, memberLike.profileExtra) : '') + '</div>'
        +   (userTag ? '<div style="color:var(--accent-primary); font-weight:600; font-size:0.9em;">@' + _soEsc(userTag) + '</div>' : '')
        +   '<small style="color:var(--text-secondary);">' + emailLine + '</small></div>'
        + '</div>'
        + ((p.bio && !_blocat) ? '<p style="margin-bottom:10px;"><strong>' + window.t('pf.about') + ':</strong> ' + _soEsc(p.bio) + '</p>' : '')
        + '<div id="ppOwnedGames"></div>'
        + favHtml
        + publicFields
        + spaceHtml
        + clubsHtml
        + '<div id="ppCharEvolution"></div>'
        + bggHtml
        /* fără nicio acțiune (propriul profil) ⇒ fără rândul gol cu linie despărțitoare */
        + (ppActs.trim() ? '<div class="pf-actions-row" style="display:flex; gap:10px; align-items:center; flex-wrap:wrap; margin-top:16px; border-top:1px solid var(--border); padding-top:14px;">'
        +   ppActs
        + '</div>' : '')
        + '</div>';
    document.body.appendChild(modal);
    /* ⚠ Inregistrat pentru redeschidere: blocarea trebuie sa ascunda datele pe loc,
         nu la refresh (vezi `_blkReopenProfile` din block.js). */
    try { if (typeof window.registerProfileModal === 'function' && id) window.registerProfileModal(id, function () { window.openPublicProfileById(id, name); }); } catch (e) { logError('openPublicProfileById', e); }
    /* §3: „Jocuri deținute" — RLS limitează automat la cluburile pe care le avem în comun. */
    try { if (id && typeof window.injectOwnedGames === 'function') window.injectOwnedGames(modal.querySelector('#ppOwnedGames'), id, p); } catch (e) { logError('openPublicProfile.owned', e); }
    try { if (window.TO_CAMP && typeof window.TO_CAMP.injectCharEvolution === 'function' && id) window.TO_CAMP.injectCharEvolution('ppCharEvolution', id); } catch (e) { logError('openPublicProfile.evo', e); }
};

window.openPublicProfileById = async function (id, fallbackName) {
    if (!id) return;
    if (!sb) return;
    /* v9 8.1-c1 — VITEZĂ (raportat de Alex: profilurile se deschid „foarte lent").
       Cauza: 4–5 drumuri la server UNUL DUPĂ ALTUL (profil → cluburi → spațiu →
       email → statistici, ultimul în `openPublicProfile`), iar fereastra apărea abia
       după SUMA lor. Toate depind doar de `id`, deci pornesc ÎMPREUNĂ: fereastra
       apare după cel mai lent. Statisticile intră în același pachet (fără ele aici,
       `openPublicProfile` le-ar cere a doua oară: `_playerStatsAsked` se notează abia
       la răspuns), apoi acolo se rezolvă din cache, fără cerere.
       Fiecare cerere secundară își prinde singură eroarea, ca înainte: o cerere
       căzută lasă secțiunea ei goală, nu blochează profilul.
       Diferență mică față de înainte: cluburile / spațiul / emailul se cer și când
       profilul nu există (caz rar, cade pe profilul minimal de mai jos).
       EN: the 4–5 profile requests now run in parallel instead of in sequence. */
    var _safe = function (pr, where) {
        return Promise.resolve(pr).catch(function (e) { logError(where, e); return null; });
    };
    try {
        var all = await Promise.all([
            sb.from('profiles').select(window.PROFILE_COLS).eq('id', id).maybeSingle(),
            _safe(sb.rpc('public_clubs_for_profiles', { ids: [id] }), 'openPublicProfileById.clubs'),
            _safe(sb.rpc('profile_spaces_for', { p_ids: [id] }), 'openPublicProfileById.space'),
            /* 9.6: adresa NU vine din `select` (coloana nu e expusă): din datele deja
               hidratate sau, pentru cineva din afara cluburilor mele, de la server. */
            _safe((typeof window.fetchVisibleEmail === 'function') ? window.fetchVisibleEmail(id) : null, 'openPublicProfileById.email'),
            _safe((typeof window.ensurePlayerStats === 'function') ? window.ensurePlayerStats([id]) : null, 'openPublicProfileById.stats')
        ]);
        var res = all[0];
        if (res && res.data) {
            var p = res.data;
            /* Cluburi publice ale jucătorului (mutate în pop-up din cardul de Discover). */
            var clubs = [];
            var cr = all[1];
            if (cr && cr.data) clubs = cr.data.filter(function (r) { return r.profile_id === id; }).map(function (r) { return r.club_name; });
            /* Spațiu fizic (gated server-side pe vizibilitate). */
            var space = null;
            var sr = all[2];
            if (sr && sr.data && sr.data.length) space = sr.data[0];
            var _em = all[3] || null;
            window.openPublicProfile({
                id: p.id, name: p.name, email: _em, avatar: p.avatar, bio: p.bio,
                user_tag: p.user_tag || '', bgg_username: p.bgg_username || '',
                hide_email: p.hide_email, preferred_games: p.preferred_games, clubs: clubs, space: space,
                profileExtra: (p.profile_extra && typeof p.profile_extra === 'object' && !Array.isArray(p.profile_extra)) ? p.profile_extra : null
            });
            return;
        }
    } catch (e) { logError('closeAnyModalSafe', e); }
    // fallback: profil minimal
    window.openPublicProfile({ id: id, name: fallbackName || window.t('dm.someone') });
};

window.confirmRemoveFriend = async function (id) {
    if (!await confirmModal(window.t('friends.removeConfirm'), { danger: true })) return;
    if (typeof removeFriend === 'function') removeFriend(id);
    if (typeof renderMyProfile === 'function') renderMyProfile();
};

/* ---------- Listă de prieteni (în „Profilul meu") ---------- */
window._friendsAccOpen = window._friendsAccOpen || false;
window._friendsExpanded = window._friendsExpanded || false;
window.toggleFriendsAcc = function () {
    window._friendsAccOpen = !window._friendsAccOpen;
    var sec = document.getElementById('myFriendsSection');
    if (sec && typeof window.renderMyFriendsHTML === 'function') sec.innerHTML = window.renderMyFriendsHTML();
};
window.toggleFriendsExpanded = function () {
    window._friendsExpanded = !window._friendsExpanded;
    var sec = document.getElementById('myFriendsSection');
    if (sec && typeof window.renderMyFriendsHTML === 'function') sec.innerHTML = window.renderMyFriendsHTML();
};

/* ---------- Căutare în lista de prieteni (aug. 2026) ----------
   RO: cu peste 10 prieteni, lista e oricum tăiată la 10 + „Arată mai mult", deci
       găsirea cuiva anume devenea o vânătoare. Căutarea filtrează după nume ȘI după
       @etichetă, cu potrivire parțială, insensibilă la majuscule și la diacritice
       (cine scrie „ion" trebuie să-l găsească pe „Ion").
   ⚠ FĂRĂ cerere la server: filtrăm lista DEJA încărcată în memorie (`_friendNames`,
       `_friendTags`). Zero cereri noi, zero latență — și, la fel de important, nicio
       cale nouă prin care s-ar putea scurge date despre alți utilizatori.
   ⚠ FĂRĂ capabilitate nouă (regula 8): lista de prieteni e strict personală, iar
       filtrarea nu descoperă nimic ce utilizatorul nu vedea deja derulând. Nu există
       prag de rol de aliniat cu serverul, fiindcă serverul nu e implicat.
   EN: filters the already-loaded friend list by name and @tag — accent- and
       case-insensitive, partial match. No server call, so no new data-exposure path,
       and no capability gate to align (the list is personal and already visible). */
window._friendsSearchOpen = window._friendsSearchOpen || false;
window._friendsQuery = window._friendsQuery || '';

/* Normalizare pentru căutare: minuscule + fără diacritice.
   EN: lowercase + strip diacritics so "ion" matches "Ion" and "Ștefan" matches "stefan". */
window._friendsNorm = function (v) {
    var t = String(v == null ? '' : v).toLowerCase();
    try { t = t.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) { /* browser vechi: mergem pe minuscule */ }
    return t;
};

window.toggleFriendsSearch = function () {
    window._friendsSearchOpen = !window._friendsSearchOpen;
    /* Deschiderea căutării deschide și acordeonul — altfel câmpul ar fi ascuns. */
    if (window._friendsSearchOpen) window._friendsAccOpen = true;
    else window._friendsQuery = '';   /* închiderea curăță filtrul, ca lista să revină întreagă */
    var sec = document.getElementById('myFriendsSection');
    if (sec && typeof window.renderMyFriendsHTML === 'function') sec.innerHTML = window.renderMyFriendsHTML();
    if (window._friendsSearchOpen) window._friendsFocusSearch();
};

window.onFriendsSearchInput = function (el) {
    window._friendsQuery = el ? el.value : '';
    var sec = document.getElementById('myFriendsSection');
    if (sec && typeof window.renderMyFriendsHTML === 'function') sec.innerHTML = window.renderMyFriendsHTML();
    /* ⚠ Re-randăm tot blocul la fiecare tastă, deci câmpul e recreat și pierde focusul.
       Îl redăm imediat, cu cursorul la final — altfel nu s-ar putea scrie mai mult de
       o literă. EN: the input is recreated on every keystroke, so refocus it. */
    window._friendsFocusSearch();
};

window._friendsFocusSearch = function () {
    try {
        var inp = document.getElementById('friendsSearchInput');
        if (!inp) return;
        inp.focus();
        var n = inp.value.length;
        try { inp.setSelectionRange(n, n); } catch (e) { /* unele tipuri de input nu suportă */ }
    } catch (e) { /* niciodată nu blocăm randarea din cauza focusului */ }
};
window.renderMyFriendsHTML = function () {
    var T = window.t;
    var FB = (typeof _friendsById !== 'undefined' && _friendsById) || {};
    var FN = (typeof _friendNames !== 'undefined' && _friendNames) || {};
    var ids = Object.keys(FB).filter(function (id) { return FB[id].status === 'accepted'; });
    var incoming = Object.keys(FB).filter(function (id) { return FB[id].status === 'pending' && FB[id].dir === 'in'; });

    var html = '';

    // Badge numeric pentru butonul de cereri (semnal „ceva nou", vizibil și colapsat)
    var reqN = incoming.length;
    var reqBadge = reqN
        ? '<span style="position:absolute; top:-7px; right:-7px; min-width:18px; height:18px; padding:0 5px; '
          + 'border-radius:9px; background:var(--accent-primary,#e07a5f); color:#fff; font-size:0.72em; font-weight:700; '
          + 'display:inline-flex; align-items:center; justify-content:center; box-shadow:0 0 0 2px var(--bg-primary,#1a1a1a);">'
          + (reqN > 99 ? '99+' : reqN) + '</span>'
        : '';

    // Header-ul acordeonului „Prietenii mei (N)" + butonul „Cereri" pe aceeași linie
    var open = !!window._friendsAccOpen;
    html += '<div class="friends-acc-headrow" style="display:flex; align-items:stretch; gap:8px;">';
    html +=   '<button type="button" class="admin-acc-head friends-acc-head' + (open ? ' is-open' : '') + '" style="flex:1; min-width:0;" onclick="toggleFriendsAcc()">'
          +     '<span><i class="fas fa-user-group"></i> ' + T('friends.title') + ' (' + ids.length + ')</span>'
          +     '<i class="fas fa-chevron-down admin-acc-chev"></i></button>';
    /* Buton de căutare — în STÂNGA celui de cereri, cum a fost cerut.
       Ascuns când nu ai niciun prieten: n-ar avea ce filtra.
       EN: search toggle, left of the requests button; hidden when there are no friends. */
    if (ids.length) {
        html += '<button type="button" class="tab-head-btn friends-search-btn' + (window._friendsSearchOpen ? ' is-on' : '') + '" '
              +   'title="' + window.attrJs(T('friends.search')) + '" aria-label="' + window.attrJs(T('friends.search')) + '" '
              +   'onclick="event.stopPropagation(); toggleFriendsSearch()">'
              +   '<i class="fas fa-magnifying-glass"></i>'
              + '</button>';
    }
    /* ⚠ ASPECT (aug. 2026): butoanele astea aveau stiluri INLINE proprii, deci arătau
       diferit de restul aplicației și erau mai scunde decât antetul acordeonului.
       Trecute pe `.tab-head-btn` — clasa deja folosită pentru butoanele-unealtă din
       cardurile de pe Dashboard (ex. „Deschide evenimentul" / „Adaugă în calendar").
       O singură clasă înseamnă că o viitoare schimbare de temă le prinde pe toate.
       Înălțimea o aliniază regula `.friends-acc-headrow .tab-head-btn` din style.css.
       EN: these had bespoke inline styles, so they looked unlike the rest of the app and
       were shorter than the accordion header. Now on `.tab-head-btn`, the shared
       tool-button class used by the dashboard cards; height is matched in style.css. */
    html +=   '<button type="button" class="tab-head-btn" title="' + window.attrJs(T('friends.requests')) + '" '
          +     'onclick="event.stopPropagation(); openFriendRequestsModal()">'
          +     '<i class="fas fa-user-plus"></i>' + reqBadge
          +   '</button>';
    html += '</div>';
    html += '<div class="admin-acc-body friends-acc-body' + (open ? '' : ' hidden') + '">';
    /* Câmpul de căutare, doar când butonul e activ. Stă în CORPUL acordeonului, ca să
       nu înghesuie antetul pe telefon. EN: search box lives in the accordion body. */
    if (ids.length && window._friendsSearchOpen) {
        html += '<div class="friends-search-row" style="display:flex; gap:8px; margin:2px 0 10px;">'
              +   '<input type="text" id="friendsSearchInput" class="form-control" autocomplete="off" '
              +     'placeholder="' + window.attrJs(T('friends.searchPh')) + '" '
              +     'value="' + window.attrJs(window._friendsQuery || '') + '" '
              +     'oninput="onFriendsSearchInput(this)" style="flex:1; min-width:0;">'
              + '</div>';
    }
    /* Filtrarea se aplică ÎNAINTE de limita de 10, ca „Arată mai mult" să numere
       rezultatele căutării, nu lista întreagă.
       EN: filter before slicing, so the "show more" count reflects the search results. */
    var q = window._friendsSearchOpen ? window._friendsNorm(window._friendsQuery || '').trim() : '';
    var matched = ids;
    if (q) {
        matched = ids.filter(function (id) {
            var nm = window._friendsNorm(FN[id] || '');
            var tg = window._friendsNorm((typeof _friendTags !== 'undefined' && _friendTags[id]) || '');
            return nm.indexOf(q) > -1 || tg.indexOf(q) > -1;
        });
    }

    if (!ids.length) {
        html += '<p style="color:var(--text-secondary); font-size:0.88em; margin:4px 0;">' + T('friends.none') + '</p>';
    } else if (!matched.length) {
        html += '<p style="color:var(--text-secondary); font-size:0.88em; margin:4px 0;">' + T('friends.noMatch') + '</p>';
    } else {
        var LIMIT = 10;
        var expanded = !!window._friendsExpanded;
        var shown = expanded ? matched : matched.slice(0, LIMIT);
        html += '<div class="friend-list">' + shown.map(function (id) {
            var nm = _soEsc(FN[id] || '—');
            var av = (typeof _friendAvatars !== 'undefined' && _friendAvatars[id]) || '';
            var tg = (typeof _friendTags !== 'undefined' && _friendTags[id]) || '';
            var avHtml = (typeof avatarHtml === 'function') ? avatarHtml(av, 38) : '';
            return '<div class="friend-row">'
                + '<a class="friend-id-link" href="javascript:void(0)" onclick="openPublicProfileById(\'' + id + '\')">'
                +   '<span class="friend-avatar">' + avHtml + '</span>'
                +   '<span class="friend-id-text">'
                +     '<span class="friend-name-line">' + nm + '</span>'
                +     (tg ? '<span class="friend-tag-line">@' + _soEsc(tg) + '</span>' : '')
                +   '</span>'
                + '</a>'
                + '<span class="friend-actions">'
                +   '<button class="btn btn-sm" onclick="openDM(\'' + id + '\', \'' + window.attrJs(nm) + '\')"><i class="fas fa-paper-plane"></i> ' + T('dm.send') + '</button>'
                + '</span></div>';
        }).join('') + '</div>';
        if (matched.length > LIMIT) {
            html += '<div style="text-align:center; margin-top:10px;">'
                  + '<button type="button" class="btn btn-sm btn-secondary players-more-btn" onclick="toggleFriendsExpanded()">'
                  + (expanded ? ('<i class="fas fa-chevron-up"></i> ' + T('players.showLess'))
                              : ('<i class="fas fa-chevron-down"></i> ' + T('players.showMore') + ' (' + (matched.length - LIMIT) + ')'))
                  + '</button></div>';
        }
    }
    html += '</div>';
    return html;
};

/* ---------- Pop-up dedicat „Cereri de prietenie" ---------- */
window.renderFriendRequestsListHTML = function () {
    var T = window.t;
    var FB = (typeof _friendsById !== 'undefined' && _friendsById) || {};
    var FN = (typeof _friendNames !== 'undefined' && _friendNames) || {};
    var incoming = Object.keys(FB).filter(function (id) { return FB[id].status === 'pending' && FB[id].dir === 'in'; });
    if (!incoming.length) {
        return '<p style="color:var(--text-secondary); font-size:0.9em; text-align:center; padding:18px 6px;">' + T('friends.noRequests') + '</p>';
    }
    return incoming.map(function (id) {
        var nm = _soEsc(FN[id] || '—');
        var av = (typeof _friendAvatars !== 'undefined' && _friendAvatars[id]) || '';
        var tg = (typeof _friendTags !== 'undefined' && _friendTags[id]) || '';
        var avHtml = (typeof avatarHtml === 'function') ? avatarHtml(av, 40) : '';
        return '<div class="friend-row friend-row-pending" style="display:flex; align-items:center; gap:10px; padding:9px 0; border-bottom:1px solid var(--border,#2a2a2a);">'
            + '<a href="javascript:void(0)" onclick="openPublicProfileById(\'' + id + '\')" style="display:flex; align-items:center; gap:10px; flex:1; min-width:0; text-decoration:none; color:inherit;">'
            +   '<span class="friend-avatar">' + avHtml + '</span>'
            +   '<span style="min-width:0;">'
            +     '<span class="friend-name-line" style="display:block; font-weight:600; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">' + nm + '</span>'
            +     (tg ? '<span class="friend-tag-line" style="display:block; font-size:0.8em; color:var(--accent-primary);">@' + _soEsc(tg) + '</span>' : '')
            +   '</span>'
            + '</a>'
            + '<span class="friend-actions" style="display:flex; gap:6px; flex-shrink:0;">'
            +   '<button class="btn btn-sm btn-success" title="' + T('friend.accept') + '" onclick="acceptFriendRequest(\'' + id + '\', this).then(friendReqModalRefresh)"><i class="fas fa-check"></i></button>'
            /* 26 oct.: refuzul are acum calea lui (mai jos), nu ștergerea prieteniei („Prietenie eliminată") */
            +   '<button type="button" class="btn btn-sm btn-secondary" title="' + _soEsc(T('friend.refuse')) + '" aria-label="' + _soEsc(T('friend.refuse')) + '" data-action="friend-decline" data-id="' + _soEsc(String(id)) + '"><i class="fas fa-xmark" aria-hidden="true"></i></button>'
            + '</span></div>';
    }).join('');
};
/* 26 oct. 2026 (cererile lui Alex) — „Refuză" la o cerere de prietenie PRIMITĂ (în profil, lângă
   „Acceptă", și în fereastra „Cereri de prietenie", unde ✕ folosea ștergerea prieteniei, cu mesajul
   „Prietenie eliminată") și „Anulează cererea" la una TRIMISĂ (în profil, lângă „Cerere trimisă").
   RO: Pe server, aceeași ștergere ca la „Șterge prietenia" (regulile RLS de pe `friendships`),
       restrânsă aici la cererea ÎN AȘTEPTARE dintre noi doi, în sensul potrivit (refuz: el → eu;
       anulare: eu → el). RLS nu dă eroare, doar filtrează ⇒ numărăm rândurile șterse; 0 ⇒ recitim
       (poate a dispărut între timp) și spunem doar dacă cererea chiar a rămas. Celălalt NU e anunțat;
       cererea se poate retrimite. Fără prag de rang: acțiuni strict personale. Delegare pe
       `data-action`, la captură (o fereastră de deasupra poate opri propagarea), fără `onclick` nou.
   EN: decline an incoming / cancel an outgoing pending request (delete that pending row). */
(function () {
    var busy = {};
    var KIND = {
        'friend-decline': { dir: 'in', ok: 'friend.declined', err: 'friend.declineErr' },
        'friend-cancel': { dir: 'out', ok: 'friend.cancelled', err: 'friend.cancelErr' }
    };
    function refresh(otherId) {
        ['renderNotifBadge', 'renderNotifPanel', 'renderMyProfile'].forEach(function (f) {
            try { if (typeof window[f] === 'function') window[f](); } catch (e) { logError('friendDrop', e); }
        });
        try { if (typeof window.refreshFriendsUi === 'function') window.refreshFriendsUi(); } catch (e) { logError('friendDrop', e); }
        try { if (typeof _refreshFriendBtns === 'function') _refreshFriendBtns(otherId); } catch (e) { logError('friendDrop', e); }
    }
    function drop(action, otherId, btn) {
        var me = _soMe(), k = KIND[action];
        if (!k || !otherId || !me || busy[otherId] || !sb) return Promise.resolve(false);
        if (typeof isDemoMode === 'function' && isDemoMode()) { showNotification(window.t('sb.unavailableDemo'), 'info'); return Promise.resolve(false); }
        busy[otherId] = true;
        if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
        var undo = function () { delete busy[otherId]; if (btn && btn.isConnected) { btn.disabled = false; btn.removeAttribute('aria-busy'); } };
        var from = k.dir === 'in' ? otherId : me, to = k.dir === 'in' ? me : otherId;
        return Promise.resolve(sb.from('friendships').delete().eq('requester_id', from).eq('addressee_id', to).eq('status', 'pending').select('id'))
            .then(function (r) {
                if (r && r.error) throw r.error;
                if (r && Array.isArray(r.data) && r.data.length) return true;
                return Promise.resolve(typeof loadFriendData === 'function' ? loadFriendData() : null).then(function () {
                    var f = (typeof _friendsById !== 'undefined' && _friendsById) ? _friendsById[otherId] : null;
                    return !(f && f.status === 'pending' && f.dir === k.dir);   /* a dispărut oricum ⇒ ok */
                });
            })
            .then(function (gone) {
                undo();
                if (!gone) { showNotification(window.t(k.err), 'error'); return false; }
                try { if (typeof _friendsById !== 'undefined' && _friendsById) delete _friendsById[otherId]; } catch (e) { logError('friendDrop', e); }
                refresh(otherId);
                showNotification(window.t(k.ok), 'info');
                return true;
            }, function (e) {
                undo();
                logError('friendDrop', e);
                showNotification(window.t(k.err), 'error');
                return false;
            });
    }
    try {
        document.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-action="friend-decline"], [data-action="friend-cancel"]') : null;
            if (!b) return;
            e.preventDefault();
            e.stopPropagation();
            drop(b.getAttribute('data-action'), b.getAttribute('data-id'), b);
        }, true);
    } catch (e) { logError('friendDrop', e); }
})();
window.friendReqModalRefresh = function () {
    var body = document.getElementById('friendReqModalBody');
    if (body) body.innerHTML = window.renderFriendRequestsListHTML();
};
/* Reîmprospătare LIVE a UI-ului de prieteni (secțiunea din profil + pop-up),
   apelată din realtime (friendships) și din poll-ul de notificări.
   Acordeonul își păstrează starea (window._friendsAccOpen/_friendsExpanded). */
/* Ultima amprentă de prietenie pe care am randat-o efectiv. Memoria stă AICI, la
   consumator, nu la producător: `refreshFriendsUi` e singura care știe ce a desenat. */
var _friendUiSig = null;
window.refreshFriendsUi = function () {
    try {
        var sec = document.getElementById('myFriendsSection');
        if (sec && typeof window.renderMyFriendsHTML === 'function') {
            /* ⚠ Reținem dacă utilizatorul scria CHIAR ACUM în câmpul de căutare.
               Funcția asta e chemată din realtime și din poll-ul de notificări, adică la
               momente pe care utilizatorul nu le controlează — fără linia asta, o
               notificare sosită în timp ce tastezi ți-ar fura cursorul din câmp.
               EN: this runs from realtime/polling, so remember whether the search box was
               focused and give the caret back after the re-render. */
            var wasFocused = (document.activeElement && document.activeElement.id === 'friendsSearchInput');
            sec.innerHTML = window.renderMyFriendsHTML();
            if (wasFocused && typeof window._friendsFocusSearch === 'function') window._friendsFocusSearch();
        }
    } catch (e) { logError('closeAnyModalSafe', e); }
    try {
        if (document.getElementById('friendReqModal')) window.friendReqModalRefresh();
    } catch (e) { logError('closeAnyModalSafe', e); }
    /* ⚠ DEFECTUL REPARAT: butoanele `[data-friend-btn]` din modalele de profil și
         lista din „Descoperă jucători" NU erau atinse de nimic aici. `acceptFriendRequest`
         le reîmprospăta, dar numai la cel care ACCEPTĂ. Cel care TRIMISESE cererea
         rămânea pe „Cerere trimisă" până la o reîncărcare completă, deși datele
         proaspete sosiseră deja prin realtime sau prin poll.
       ⚠ Se pune AICI, nu în ascultătorul realtime: `refreshFriendsUi` e punctul comun
         prin care trec ambele căi (realtime `friendships` și `_notifRefreshAll`), deci
         o singură reparație acoperă și cazul în care realtime nu ajunge.
       ⚠ Gardat pe amprentă: fără ea, poll-ul de 20 de secunde ar redesena lista
         Descoperă la nesfârșit, resetând derularea și căutarea utilizatorului.
       ⚠ `renderDiscoverPlayers` are butoane proprii, care NU poartă `data-friend-btn`
         — de aceea are nevoie de apel separat; `_refreshFriendBtns` nu ajunge la ele.
       EN: refresh the friendship buttons and the Discover list for the REQUESTER too,
           gated on a fingerprint so the 20s poller doesn't redraw needlessly. */
    try {
        const sig = (typeof window._friendSignature === 'function') ? window._friendSignature() : null;
        if (sig === null || sig !== _friendUiSig) {
            _friendUiSig = sig;
            try { if (typeof _refreshFriendBtns === 'function') _refreshFriendBtns(); } catch (e) { logError('refreshFriendsUi', e); }
            try { if (typeof renderDiscoverPlayers === 'function') renderDiscoverPlayers(); } catch (e) { logError('refreshFriendsUi', e); }
        }
    } catch (e) { logError('refreshFriendsUi', e); }
};
window.openFriendRequestsModal = function () {
    var existing = document.getElementById('friendReqModal'); if (existing) existing.remove();
    var modal = document.createElement('div');
    modal.className = 'modal active'; modal.id = 'friendReqModal';
    if (modal.dataset) modal.dataset.dynamic = '1';
    modal.onclick = function (e) { if (e.target === modal) modal.remove(); };
    modal.innerHTML =
        '<div class="modal-content" style="max-width:460px;">'
        + '<div class="modal-header">'
        +   '<h2><i class="fas fa-user-plus"></i> ' + window.t('friends.requests') + '</h2>'
        +   '<button class="modal-close" onclick="this.closest(\'.modal\').remove()">×</button>'
        + '</div>'
        + '<div id="friendReqModalBody">' + window.renderFriendRequestsListHTML() + '</div>'
        + '</div>';
    document.body.appendChild(modal);
};